import { useAccount, useMsal } from "@azure/msal-react";
import { useEffect, useState } from "react";

export default function useAuthToken() {
    const { accounts } = useMsal();	
    const account = useAccount(accounts[0]);
    const [ objectId, setObjectId ] = useState(); 

    useEffect(() => {
        setObjectId(account?.idTokenClaims?.oid);
    }, [account]);

    return {
        objectId
    };
}